import React from 'react'
import { localizer } from '../../Translator'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import PasswordStrengthBar from 'react-password-strength-bar'

import Typography from '@material-ui/core/Typography'

/**
 * Box informing about the requirements for a valid and strong password.
 * Live updated with the currently typed password. The password is received
 * as property as it is being typed.
 */
export class PassStrength extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      hasMinLength: false,
      hasDigit: false,
      hasLower: false,
      hasUpper: false,
      hasSymbol: false,
      hasDifferent: false,
      passwordAttempt: ''
    }

    // Defines the number of minimum length for a password and number of different characters.
    // These values have to match those in the auth service.
    this.passMinLength = 8
    this.passMinDifferentChars = 4
  }

  /**
   * The typed password has changed. Strength checkings are refreshed.
   */
  componentDidUpdate(prevProps) {
    if (prevProps === this.props) return
    this.checkStrength()
  }

  /**
   * Updates the component's state with the different password validation checkings
   * by considering the current password in properties.
   */
  checkStrength() {
    // Remember previous validity state.
    var wasValid = this.state.hasMinLength && this.state.hasDigit && this.state.hasLower && this.state.hasUpper && this.state.hasSymbol && this.state.hasDifferent

    // Determine checkings for new password.
    var nowPasswordAttempt = this.props.passwordAttempt
    var nowHasMinLength = nowPasswordAttempt.length >= this.passMinLength
    var nowHasDigit = /\d/.test(nowPasswordAttempt)
    var nowHasLower = /[a-z]/.test(nowPasswordAttempt)
    var nowHasUpper = /[A-Z]/.test(nowPasswordAttempt)
    var nowHasSymbol = /\W/.test(nowPasswordAttempt)
    const charSet = new Set()
    nowPasswordAttempt.split('').map(character => { charSet.add(character); return null })
    var nowHasDifferent = charSet.size >= this.passMinDifferentChars

    // Determine overall validity.
    var isNowValid = nowHasMinLength && nowHasDigit && nowHasLower && nowHasUpper && nowHasSymbol && nowHasDifferent
   
    // Update internal state.
    this.setState({
      passwordAttempt: nowPasswordAttempt,
      hasMinLength: nowHasMinLength,
      hasDigit: nowHasDigit,
      hasLower: nowHasLower,
      hasUpper: nowHasUpper,
      hasSymbol: nowHasSymbol,
      hasDifferent: nowHasDifferent
    })

    // Callback if validation has changed. The other component with the form must refresh its button.
    if (wasValid !== isNowValid) this.props.onValidationChange(isNowValid)
  }

  render() {
    const labelresult = localizer.StrengthOfPassword + " "
    return (
    
      <React.Fragment>
        <Paper elevation={2} className="p-10" style={{ height: "350px" }}>
          <Grid container>

            {/* Top message */}
            <Grid item xs={12}>
              <Typography className="typography-generic" variant="body1" display="block" gutterBottom>{localizer.PasswordMustMeet}</Typography>
            </Grid>

            {/* Checkings list */}
            <Grid container>
              <Grid item xs={12} className="pt-10 pb-10 pl-20 pr-20">
                <Grid container direction="row" alignItems="center">
                  {this.state.hasMinLength ? <i className="fa-solid fa-circle-check" style={{ color: 'var(--custom-success-color)' }} /> :
                    <i className="fa-solid fa-circle-check disabled disabledPass"></i>}
                  <Typography className="typography-generic" variant="body2" display="inline" style={{ marginLeft: 10 }} >{localizer.formatString(localizer.RequiredMinLength, this.passMinLength)}</Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} className="pt-10 pb-10 pl-20 pr-20">
                <Grid container direction="row" alignItems="center">
                  {this.state.hasDigit ? <i className="fa-solid fa-circle-check" style={{ color: 'var(--custom-success-color)' }} /> :
                    <i className="fa-solid fa-circle-check disabled disabledPass"></i>}
                  <Typography className="typography-generic" variant="body2" display="inline" style={{ marginLeft: 10 }} >{localizer.RequiredOneDigit}</Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} className="pt-10 pb-10 pl-20 pr-20">
                <Grid container direction="row" alignItems="center">
                  {this.state.hasLower ? <i className="fa-solid fa-circle-check" style={{ color: 'var(--custom-success-color)' }} /> :
                    <i className="fa-solid fa-circle-check disabled disabledPass"></i>}
                  <Typography className="typography-generic" variant="body2" display="inline" style={{ marginLeft: 10 }} >{localizer.RequiredOneLower}</Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} className="pt-10 pb-10 pl-20 pr-20">
                <Grid container direction="row" alignItems="center">
                  {this.state.hasUpper ? <i className="fa-solid fa-circle-check" style={{ color: 'var(--custom-success-color)' }} /> :
                    <i className="fa-solid fa-circle-check disabled disabledPass"></i>}
                  <Typography className="typography-generic" variant="body2" display="inline" style={{ marginLeft: 10 }} >{localizer.RequiredOneUpper}</Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} className="pt-10 pb-10 pl-20 pr-20">
                <Grid container direction="row" alignItems="center">
                  {this.state.hasSymbol ? <i className="fa-solid fa-circle-check" style={{ color: 'var(--custom-success-color)' }} /> :
                    <i className="fa-solid fa-circle-check disabled disabledPass"></i>}
                  <Typography className="typography-generic" variant="body2" display="inline" style={{ marginLeft: 10 }} >{localizer.RequiredOneNonAlpha}</Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} className="pt-10 pb-10 pl-20 pr-20">
                <Grid container direction="row" alignItems="center">
                  {this.state.hasDifferent ? <i className="fa-solid fa-circle-check" style={{ color: 'var(--custom-success-color)' }} /> :
                    <i className="fa-solid fa-circle-check disabled disabledPass"></i>}
                  <Typography className="typography-generic" variant="body2" display="inline" style={{ marginLeft: 10 }} >{localizer.formatString(localizer.RequiredMinDiffChars, this.passMinDifferentChars)}</Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
            </Grid>

            {/* Strength indicator */}
            <Grid item xs={12}>
              {/* <Typography  className="typography-generic"  variant="body1" display="block" gutterBottom>{localizer.StrengthOfPassword}</Typography> */}
              <PasswordStrengthBar
                password={this.state.passwordAttempt}
                minLength={this.passMinLength}
                shortScoreWord={localizer.PassStrengthShort}
                scoreWords={[
                  labelresult + localizer.PassStrengthVeryWeak,
                  labelresult + localizer.PassStrengthWeak,
                  labelresult + localizer.PassStrengthAcceptable,
                  labelresult + localizer.PassStrengthGood,
                  labelresult + localizer.PassStrengthStrong
                ]}
                scoreWordClassName='typography-generic'
              />
            </Grid>
            
          </Grid>
        </Paper>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/password/PassStrength.js